module.exports = __webpack_public_path__ + "20f22b83.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Slide/ic_left.png
// module id = 1021
// module chunks = 1 2